import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const TableContainer = styled.div`
  width: 100%;
  margin: 0.625rem 0;
  overflow-x: auto;
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0;
`;

export const Table = styled.table`
  width: 100%;
  margin: 0;
  table-layout: auto;

  th,
  td {
    border: 0.0625rem solid ${Theme.colors.G_3};
  }

  thead {
    tr {
      border-bottom: 0.1875rem solid ${Theme.colors.G_2};
    }
  }

  tbody {
    tr:hover {
      background-color: ${Theme.colors.G_6};
    }
  }
`;

export const Tr = styled.tr`
  background-color: ${Theme.colors.WHITE};
`;

export const Th = styled.th<{ sortable?: boolean }>`
  position: relative;
  font-weight: 700;
  padding: 0.9375rem 0.3125rem;
  white-space: nowrap;
  cursor: ${({ sortable }) => (sortable ? 'pointer' : 'default')};

  &:hover {
    background-color: ${({ sortable }) => (sortable ? Theme.colors.G_6 : 'transparent')};
  }
`;

export const Td = styled.td`
  padding: 0.9375rem 0.3125rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
`;

export const SortIndicator = styled.span`
  margin-left: 0.25rem;
  font-size: 0.75rem;
  opacity: 0.6;
`;

export const StatusBadge = styled.span<{ color: string }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background-color: ${({ color }) => color};
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
`;

export const ErrorText = styled.div`
  color: ${Theme.colors.WARNING_RED};
  padding: 1rem;
  text-align: center;
`;
